import { Button, Col, Divider, Input, notification, Row } from 'antd'
import { LockFilled } from '@ant-design/icons'
import Cookies from 'js-cookie'
import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom';
import loginImage from '../../Assets/images/login-image.png'
import logoTitle from '../../Assets/images/plunes-logo-text.png'
import ForgotPasswordModal from '../../Components/ForgotPassword';
import GlobalLoader from '../../Components/GlobalLoader';

const mailIcon = (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.172 8.834L10.002 10.769L12.73 8.887L18.845 14.92C18.684 14.972 18.512 15 18.333 15H1.667C1.447 15 1.237 14.957 1.044 14.88L7.172 8.834ZM20 3.876V13.333C20 13.58 19.946 13.814 19.85 14.025L13.856 8.111L20 3.876ZM9.43602e-07 3.929L6.042 8.061L0.106001 13.919C0.0356967 13.7316 -0.000212233 13.5331 9.43602e-07 13.333V3.929ZM18.333 0C19.253 0 20 0.746 20 1.667V2.253L9.998 9.148L9.43602e-07 2.31V1.667C9.43602e-07 0.747 0.746001 0 1.667 0H18.333Z" fill="#5E5D5D"/>
    </svg>
)

const lockIcon = (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.89 4.82L6.25 3.16C6.61681 2.22836 7.25557 1.4287 8.08313 0.865101C8.91069 0.301501 9.88875 5.71153e-05 10.89 0C13.65 0 15.89 2.24 15.89 5V7H16.89C17.4204 7 17.9291 7.21071 18.3042 7.58579C18.6793 7.96086 18.89 8.46957 18.89 9V15.8L10.09 7H13.89V5C13.89 3.34 12.55 2 10.89 2C9.3 2 8 3.25 7.89 4.82ZM21 20.46L19.73 21.73L18.35 20.35C17.99 20.75 17.47 21 16.89 21H4.89C3.78 21 2.89 20.11 2.89 19V9C2.89 8.46957 3.10071 7.96086 3.47579 7.58579C3.85086 7.21071 4.35957 7 4.89 7H5L0 2L1.28 0.73L21 20.46ZM12.74 14.74L10.15 12.15C9.39 12.44 8.89 13.16 8.89 14C8.89 14.5304 9.10071 15.0391 9.47579 15.4142C9.85086 15.7893 10.3596 16 10.89 16C11.73 16 12.45 15.5 12.74 14.74Z" fill="#5E5D5D"/>
    </svg>
)

function Login(props) {
    const [forgotPasswordModal, setForgotPasswordModal] = useState(false)
    const [loading, setLoading] = useState(false)

    const [loginCred, setLoginCred] = useState({
        loginId: "",
        password: ""
    })

    const [showPassword, setShowPassword] = useState(false)

    const togglePassword = () => {
        setShowPassword(!showPassword)
    }

    const submit = async () => {
        setLoading(true)
        await props.login({
            mobileNumber: loginCred.loginId,
            password: loginCred.password
        })
        setLoading(false)
    }

  return (
    <>
    {loading && <GlobalLoader/>}
    <div className="auth-page-container fade-in login">
        <div className='dot child-1'></div>
        <div className='dot child-2'></div>
        <div className='dot child-3'></div>
        <div className='circle child1'></div>
        <div className='circle child2'></div>
        <Row className="auth-page-row">
            <Col className="auth-image-container" span={14}>
                {/* <h3>Log In To Your Account</h3> */}
                <img className="login-left-image" src={loginImage} />
            </Col>
            <Col className="auth-form-container" span={10}>
                <div className="auth-box">
                    <img className="auth-box-image" src={logoTitle} />
                    <div className="auth-page-controller">
                        <p onClick={() => console.log("Noted")} className="page-button-main active">Welcome to Plunes</p>
                        <p onClick={() => console.log("Noted")} className="page-button-sub active">Please Login to your account</p>
                        {/* <Divider type="vertical" /> */}
                        {/* <Button onClick={() => props.setRegisterScreen()} className="page-button">Register</Button> */}
                    </div>
                    <span className='label-text'>Email or User Name</span>
                    <Input onChange={(e) => {
                        e.preventDefault()
                        setLoginCred({...loginCred, loginId: e.target.value})
                    }} className="auth-input" placeholder="Email or Username" suffix={mailIcon} />
                    <span className='label-text'>Password</span>
                    <Input onChange={(e) => {
                        e.preventDefault()
                        setLoginCred({...loginCred, password: e.target.value})
                    }} type={showPassword ? "text" : "password"} className="auth-input last" placeholder="Password" suffix={<div onClick={togglePassword} style={{cursor:'pointer', marginTop:'5px'}}>{showPassword ? <LockFilled style={{color:'#5E5D5D', fontSize:'20px'}}/> : lockIcon}</div>} />
                    {/* <Button disabled={true} className="forgot-password">Forgot Password</Button> */}

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <span className='label-text' onClick={() => setForgotPasswordModal(true)} style={{ cursor: 'pointer' }}>Forgot Password?</span>
                    </div>

                    <Button onClick={(e) => {
                        e.preventDefault()
                        submit()
                    }} className="submit-btn">Log In</Button>
                </div>
            </Col>
        </Row>

        {
            forgotPasswordModal && <ForgotPasswordModal close={() => {setForgotPasswordModal(false)}} isOpen={forgotPasswordModal} />
        }
    </div>
    </>
  )
}

export default Login